module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/onesence-9-d6c006413dde668b2053899e442f1580.webp";